"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _UserAvatar = _interopRequireDefault(require("../../preact-components/User/UserAvatar"));

var UserAvatarDropdown = function UserAvatarDropdown(_ref) {
  var user = _ref.user;
  return (0, _preact.h)("div", {
    className: "control-side-menu__menu-item-avatar"
  }, (0, _preact.h)(_dropdown.default, {
    popupName: "control-sidebar__menu-user",
    trigger: (0, _preact.h)(_UserAvatar.default, {
      user: user,
      disableLink: true
    })
  }, (0, _preact.h)("div", {
    className: "control-side-menu__menu-user"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("/member/logout")
  }, (0, _preact.h)(_assets.default, {
    icon: "logOut"
  }), "Log out"))));
};

var _default = UserAvatarDropdown;
exports.default = _default;